export default __webpack_public_path__ + "static/media/google-navy.e47824b5.svg";